import { NgModule } from '@angular/core';
import { KeyboardFocusTooltipDirective } from './keyboard-focus-tooltip.directive';

@NgModule({
    declarations: [
        KeyboardFocusTooltipDirective
    ],
    exports: [
        KeyboardFocusTooltipDirective
    ]
})
export class KeyboardFocusTooltipModule {
}
